export function arrayOfInts(n) {
    const arr = [];
    for (let i = 0; i < n; i += 1) {
        arr.push(i);
    }
    return arr;
}
